import { createFileRoute } from '@tanstack/react-router';
import { CdpRouteView } from '@/pages/workspaces/journeys/integrations/cdp/routing';
import { LastWorkspaceResolver } from './-components';

/**
 * No `appBundle`: this URL has no `journeys` segment, and the bundle-aware branch of the resolver
 * rebuilds the target from the bundle prefix — which would find no `/journeys/` here, drop the
 * sub-path, and land on the Journeys home instead of this redirect.
 */
function CdpInRoute() {
  return (
    <LastWorkspaceResolver>
      <CdpRouteView connector="cdp_in" />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/cdp_in')({
  component: CdpInRoute,
});
